<template>
	<section>
		<MainLayout>
			<div class="container">
                <div class="box">
                    <div class="text-right">
                        <b-button @click="search" variant="success" size="sm"><md-icon icon="search
                            "/> Buscar</b-button>
                    </div>
                    
                    <b-row>
                        <b-col>
                            <b-tabs v-model="activeTab">
                                <b-overlay :show="loading" no-wrap></b-overlay>
                                <b-tab
                                    v-for="(data, destination) in dataByDestination"
                                    :key="destination"
                                    :title="destination"
                                >
                                    <CalendarV :item="data" />
                                </b-tab>
                            </b-tabs>
                          
                            <!---------SIDEBAR FILTERS-------->
                            <b-sidebar id="sidebar-filters" title="Filtros" shadow sidebar-class="sidebar-filters" right backdrop >
                                <div class="px-3 py-2">
                                    <Filters
                                            id="realtime-index-filters"
                                            :filters.sync="filters"
                                            :openFiltersOpts="true"
                                            :freezFilter="false"
                                            @search="search"
                                        />
                                </div>
                                <template #footer="{ hide }">
                                    <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                                        <strong class="mr-auto"></strong>
                                        <b-button size="sm" @click="hide">Close</b-button>
                                    </div>
                                </template>
                            </b-sidebar>
                            <!---------SIDEBAR FILTERS-------->
                        </b-col>
                    </b-row>
                </div>
			</div>
		</MainLayout>
	</section>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
import Filters from "@/components/sections/reservations/Filters";
import moment from "moment";
import CalendarV from "./Calendar.vue"

import 'vue-cal/dist/vuecal.css'
export default {
	components: {
		MainLayout,
        Filters,
        CalendarV
	},
    data() {
        const now = moment().format("YYYY-MM-DD");
        let defaultFilters = {
			id: "",
			clientFullName: "",
            clientPhone: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			airport: [],
			serviceType: [],
			pickupStartDate: now,
			pickupStartTime: "",
			pickupEndDate: now,
			pickupEndTime: "", 
			creationStartDate: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
            asignationStartDate: "",
			asignationEndDate: "",
			trip: 0,
			contactStatus: 0,
			revisedStatus: null,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			onlyWithAdditionalServices: false,
			oneway: false,
			zones:[],
			invalidSupplierServiceType:false,
			withSalesChannelPromo:false,
			withSupplierPromo: false, 
			serviceTypeCategory: [],
			withChat: false,
			tags:[],
			netPriceTotalStart:null,
			netPriceTotalEnd:null,
			supplierPriceTotalStart:null,
			supplierPriceTotalEnd:null,
			fightNumber:"",
			paxMin: null,
			paxMax: null
		};
        return {
            loading:false,
            filters: { ...defaultFilters },
			defaultFilters: { ...defaultFilters },           
            dataByDestination:[],
            activeTab:0
        }
    },
    methods: {
        search(){
            this.loading=true;
            this.$root.api
				.post(`/calendar/analysis`, {filters:this.filters})
				.then((res) => {
                    this.dataByDestination = res.data;
					console.log(res)
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading=false;
                    this.activeTab=0;
				});
        },
       
        
    },

	computed: {

	},
    mounted(){
        this.search();
    }
};
</script>

<style scoped>


</style>
<style>
	/* Animation property */
.__shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}
</style>
<style>
.alert-event {
  white-space: normal;
  font-size: 11px;
  padding: 2px 4px;
  border-radius: 3px;
  background-color: #e3f2fd;
  color: #0d47a1;
  line-height: 1.2;
}

.alert-active {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.alert-icon {
  font-weight: bold;
  margin-left: 4px;
  color: #d9534f;
}

</style>
